import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFacebookF, faInstagram } from "@fortawesome/free-brands-svg-icons";
import { fetchPublicCategories } from "api/auth";
import { Category } from "interfaces/ICategory";
import logo from "assets/logo.png";
import { IconProp } from "@fortawesome/fontawesome-svg-core";
import visa from "assets/visa.png";
import paypal from "assets/paypal.png";
import mastercard from "assets/mastercard.png";
import mercadoPago from "assets/mercado-pago.png";
import oxxo from "assets/oxxo.png";
import "./Footer.scss";
import { useBreakpoints } from "hooks/useBreakPoints";
import { useNavigate } from "react-router-dom";

const Footer: React.FC = () => {
  const [categories, setCategories] = useState<Category[]>([]);
  const { isMobile } = useBreakpoints();
  const navigate = useNavigate();

  useEffect(() => {
    const loadCategories = async () => {
      try {
        const response = await fetchPublicCategories();
        setCategories(response.slice(0, 6));
      } catch (error) {
        console.error("Error loading categories:", error);
      }
    };

    loadCategories();
  }, []);

  /**
   * Handles navigation to search page with selected category
   * @param {number} categoryId - The ID of the category to filter by
   */
  const handleCategoryClick = (categoryId: number) => {
    navigate(`/search?categories=${categoryId}`);
    // Scroll to top after navigation
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 100);
  };

  /**
   * Handles navigation to terms and conditions page
   */
  const handleTermsClick = () => {
    navigate("/terms-and-conditions");
    // Scroll to top after navigation
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 100);
  };
  const handlePrivacyClick = () => {
    navigate("/privacy-policy");
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 100);
  };
  const handleFAQClick = () => {
    navigate("/faq");
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 100);
  };
  return (
    <footer className="footer">
      <Container fluid className="px-4">
        <Row className="main-footer align-items-start justify-content-between">
          <Col xs={isMobile ? 12 : 1} className="logo-column">
            <img src={logo} alt="Logo" className="footer-logo" />
          </Col>

          <Col xs={isMobile ? 12 : 3}>
            <h3 className="footer-title">Nallely Boutique</h3>
            <ul className="footer-list">
              <li>
                <a
                  href="/sobre-nosotros"
                  style={{ textDecoration: "none", color: "inherit" }}
                >
                  Sobre Nallely Boutique
                </a>
              </li>
              <li>
                <a
                  href="/contacto"
                  style={{ textDecoration: "none", color: "inherit" }}
                >
                  Contacto
                </a>
              </li>
            </ul>
          </Col>

          <Col xs={isMobile ? 12 : 2}>
            <h3 className="footer-title">Categorías</h3>
            <ul className="footer-list">
              {Array.isArray(categories) && categories.length > 0 ? (
                categories.map((category) => (
                  <li
                    key={category.id}
                    onClick={() => handleCategoryClick(category.id)}
                    style={{ cursor: "pointer" }}
                  >
                    {category.name}
                  </li>
                ))
              ) : (
                <li>No hay categorías disponibles</li>
              )}
            </ul>
          </Col>

          <Col xs={isMobile ? 12 : 3}>
            <h3 className="footer-title">Ayuda</h3>
            <ul className="footer-list">
              <li onClick={handleFAQClick} style={{ cursor: "pointer" }}>
                Preguntas frecuentes
              </li>
              <li onClick={handleTermsClick} style={{ cursor: "pointer" }}>
                Términos y condiciones
              </li>
              <li onClick={handlePrivacyClick} style={{ cursor: "pointer" }}>
                Política de privacidad
              </li>
            </ul>
          </Col>

          <Col xs={isMobile ? 12 : 3}>
            <h3 className="footer-title">Redes Sociales</h3>
            <p className="social-text">¡Síguenos en nuestras redes sociales!</p>
            <div className="social-icons">
              <a
                href="https://www.facebook.com/p/Nallely-Boutique-100063259957189/"
                className="social-link"
              >
                <FontAwesomeIcon icon={faFacebookF as IconProp} /> Facebook
              </a>
            </div>
          </Col>
        </Row>

        <Row className="payment-section">
          {!isMobile && <Col xs={1}></Col>}
          <Col xs={11}>
            <h3 className="payment-title">Formas de pago</h3>
            <div className="payment-icons">
              <img src={visa} alt="Visa" className="payment-icon" />
              <img src={paypal} alt="PayPal" className="payment-icon" />
              <img src={mastercard} alt="Mastercard" className="payment-icon" />
            </div>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;
